import type { DragUpdate, DropResult } from '@hello-pangea/dnd';
import { BANK_ID } from './types';
import { TFunction } from 'i18next';

export const liftAnnouncement = (t: TFunction, item: string) =>
  t('lifted', { item });

export const updateAnnouncement = (
  t: TFunction,
  item: string,
  update: DragUpdate,
) => {
  const destination = update.destination;
  if (!destination) return t('notOverZone', { item });
  if (destination.droppableId === BANK_ID) return t('movedToBank', { item });
  return t('movedToPosition', { item, position: destination.index + 1 });
};

export const endAnnouncement = (
  t: TFunction,
  item: string,
  result: DropResult,
) => {
  const destination = result.destination;
  if (result.reason === 'CANCEL' || !destination)
    return t('cancelled', { item });
  if (destination.droppableId === BANK_ID) return t('returnedToBank', { item });
  return t('dropped', { item, position: destination.index + 1 });
};
